/** @jsx jsx */
import { jsx } from '@emotion/react'
import React from 'react'

import InputCheckbox from './InputCheckbox'
import useIsDisabled from '../framework/hooks/useIsDisabled'
import useElemId from '../framework/hooks/useElemId'
import { InputProps } from '../framework/interfaces'

const InputUnavailableCheckbox: React.FC<InputProps> = (props) => {
  const { name, unavailableLabel } = props
  const elemId = useElemId(props)
  const isDisabled = useIsDisabled(props)

  if (!unavailableLabel) {
    return null
  }

  return (
    <div css={{ marginTop: '0.5em' }}>
      <InputCheckbox
        disabled={isDisabled}
        id={`${elemId}_unavailable`}
        label={unavailableLabel}
        name={`${name}_unavailable`}
        value="yes"
      />
    </div>
  )
}

export default InputUnavailableCheckbox
